import React, { useEffect, useState } from "react";
import AdminHeading from "../Heading/AdminHeading";
import AdminBreadCrump from "../Heading/AdminBreadCrump";
import SaveIcon from "@mui/icons-material/Save";
import ListAltIcon from "@mui/icons-material/ListAlt";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import "./Stocktransfer.css";
import {
  Box,
  Button,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Checkbox,
  Typography,
} from "@mui/material";
import { useSelector } from "react-redux";
import {
  a110,
  a125,
  a131,
  a134,
  a181,
  a185,
  a20,
  a226,
  a232,
  a233,
  a234,
  a235,
  a30,
  a98,
} from "../../../Api/RootApiPath";
import AlertMessage from "../../../Other Functions/AlertMessage";
import { useNavigate } from "react-router-dom";
import { InfinitySpin } from "react-loader-spinner";
import style from "../../LatestPages/AddNewCustomer.module.css";
import { Icon } from "@iconify/react";

function AdminStockTransfer() {
  const [checkdata, setCheckdata] = useState([]);
  const [selectedValue, setSelectedValue] = useState("labelled");
  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().slice(0, 10)
  );
  const [allCategories, setAllCategories] = useState([]);
  const [allProducts, setAllProducts] = useState([]);
  const [allDesign, setAllDesign] = useState([]);
  const [allPurity, setAllPurity] = useState([]);
  const allStates = useSelector((state) => state);
  const adminLoggedIn = allStates.reducer1;
  const clientCode = adminLoggedIn.ClientCode;
  const [selectedRows, setSelectedRows] = useState([]);
  const [packetsOption, setPacketsOption] = useState([]);
  const [boxOption, setBoxOption] = useState([]);
  const [branchOption, setBranchOption] = useState([]);
  const [salesmanOption, setSalesmanOption] = useState([]);
  const [transferType, setTransferType] = useState([]);
  const [fromOption, setFromOption] = useState([]);
  const [fromOptionKey, setFromOptionKey] = useState("");
  const [toOption, setToOption] = useState([]);
  const [toOptionKey, setToOptionKey] = useState("");
  const [selectAll, setSelectAll] = useState(false);
  const [removeAll, setRemoveAll] = useState(false);
  const [data, setData] = useState([]);
  const [allEmployee, setAllEmployee] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [showError, setShowError] = useState(false);
  const [messageType, setMessageType] = useState("");
  // const [fromId, setFromId] = useState("");
  const [messageToShow, setMessageToShow] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [filterData, setFilterData] = useState({
    CategoryName: "",
    ProductName: "",
    DesignName: "",
    PurityName: "",
  });
  const [formData, setFormData] = useState({
    TransferByEmployee: "",
    TransferedToBranch: "",
    ReceivedByEmployee: "",
    ReceivedBy: "",
    Remarks: "",
    Source: "",
    Destination: "",
    TotalGrossWT: 0,
    TotalNetWT: 0,
    StockTransferTypeName: "",
    StockTransferItems: [],
  });
  const fetchAllLabelledStock = async () => {
    setIsLoading(true);
    const formData = {
      ClientCode: clientCode,
    };
    try {
      const response = await fetch(a181, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });
      const data = await response.json();
      setTableData(data);
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };

  const fetchAllUnlabelledStock = async () => {
    setIsLoading(true);
    const formData = {
      ClientCode: clientCode,
    };
    try {
      const response = await fetch(a185, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });
      const data = await response.json();
      setTableData(data);
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };
  useEffect(() => {
    setTimeout(() => {
      setShowError(false);
    }, 2000);
  }, [showError]);
  // useEffect(() => {
  //     if (selectedValue === "labelled") {
  //         fetchAllLabelledStock();
  //     } else {
  //         fetchAllUnlabelledStock();
  //     }
  // }, [selectedValue]);
  useEffect(() => {
    let fromId;
    if (fromOptionKey === "PacketName" && formData.Source) {
      const oneItem = packetsOption.find(
        (item) => item.PacketName === formData.Source
      );
      if (oneItem) fromId = oneItem.Id;
    }
    if (fromOptionKey === "BoxName" && formData.Source) {
      const oneItem = boxOption.find(
        (item) => item.BoxName === formData.Source
      );
      if (oneItem) fromId = oneItem.Id;
    }
    if (fromOptionKey === "BranchName" && formData.Source) {
      const oneItem = branchOption?.find(
        (item) => item.BranchName === formData.Source
      );
      if (oneItem) fromId = oneItem.Id;
    }
    const getFilteredData = async () => {
      const categoryId =
        allCategories.find(
          (item, _) => item.CategoryName === filterData.CategoryName
        )?.Id || 0;
      const designId =
        allDesign.find((item, _) => item.DesignName === filterData.DesignName)
          ?.Id || 0;
      const productId =
        allProducts.find(
          (item, _) => item.ProductName === filterData.ProductName
        )?.Id || 0;
      const purityId =
        allPurity.find((item, _) => item.PurityName === filterData.PurityName)
          ?.Id || 0;

      const payload = {
        ClientCode: clientCode,
        CategoryId: categoryId,
        DesignId: designId,
        ProductId: productId,
        PurityId: purityId,
      };

      try {
        const response = await fetch(
          selectedValue === "labelled" ? a233 : a234,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(payload),
          }
        );

        const resData = await response.json();
        let resultdata = resData;
        let idKey;

        if (fromOptionKey) {
          if (fromOptionKey === "PacketName") {
            idKey = "PacketId";
          } else if (fromOptionKey === "BoxName") {
            idKey = "BoxId";
          } else if (fromOptionKey === "BranchName") {
            idKey = "BranchId";
          } else if (fromOptionKey === "FirstName") {
            idKey = "EmployeeId";
          }

          if (idKey) {
            resultdata = resData.filter((item) => item[idKey] !== 0);
            if (fromId) {
              resultdata = resultdata.filter((item) => item[idKey] == fromId);
            }
          }

          if (["DisplayName"].includes(fromOptionKey)) {
            resultdata = resData.filter(
              (item) =>
                item.PacketId === 0 && item.BoxId === 0 && item.EmployeeId === 0
            );
          }
          // if (['FirstName'].includes(fromOptionKey)) {
          //     resultdata = resData.filter((item) => item.PacketId === 0 && item.BoxId === 0);
          // }

          if (data.length > 0) {
            resultdata = resultdata.filter(
              (item2) => !data.some((item) => item.Id === item2.Id)
            );
          }

          setTableData(resultdata);
        } else {
          if (data.length > 0) {
            const filterRes = resData.filter(
              (item2) => !data.some((item) => item.Id === item2.Id)
            );
            setTableData(filterRes);
          } else {
            setTableData(resultdata);
          }
        }
      } catch (error) {
        console.log(error);
      }
    };
    getFilteredData();
  }, [filterData, formData, selectedValue]);
  const fetchAllCategories = async () => {
    const formData = { ClientCode: clientCode };
    try {
      const response = await fetch(a125, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });
      const data = await response.json();
      setAllCategories(data);
    } catch (error) {
      console.log(error);
    }
  };
  const fetchAllProducts = async () => {
    const payload = { ClientCode: clientCode };
    try {
      const response = await fetch(a20, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });
      const data = await response.json();
      setAllProducts(data);
    } catch (error) {
      console.log(error);
    }
  };
  const fetchAllDesign = async () => {
    const payload = { ClientCode: clientCode };
    try {
      const response = await fetch(a131, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });
      const data = await response.json();
      setAllDesign(data);
    } catch (error) {
      console.log(error);
    }
  };
  const fetchAllPurity = async () => {
    const payload = { ClientCode: clientCode };
    try {
      const response = await fetch(a134, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });
      const data = await response.json();
      setAllPurity(data);
    } catch (error) {
      console.log(error);
    }
  };
  const getPacket = async () => {
    const payload = { ClientCode: clientCode };
    try {
      const response = await fetch(a226, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });
      const data = await response.json();
      setPacketsOption(data);
    } catch (error) {
      console.log(error);
    }
  };
  const getAllBox = async () => {
    const payload = { ClientCode: clientCode };
    try {
      const response = await fetch(a30, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });
      const data = await response.json();
      setBoxOption(data);
    } catch (error) {
      console.log(error);
    }
  };
  const getAllBranch = async () => {
    const payload = { ClientCode: clientCode };
    try {
      const response = await fetch(a98, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });
      const data = await response.json();
      setBranchOption(data);
    } catch (error) {
      console.log(error);
    }
  };
  const getAllTransferTypes = async () => {
    const payload = { ClientCode: clientCode };
    try {
      const response = await fetch(a232, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });
      const data = await response.json();
      setTransferType(data);
    } catch (error) {
      console.log(error);
    }
  };
  const getAllEmployee = async () => {
    const payload = { ClientCode: clientCode };
    try {
      const response = await fetch(a110, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });
      const data = await response.json();
      setAllEmployee(data);
      setSalesmanOption(
        data.filter((item, _) => item.Designation == "Salesman")
      );
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchAllCategories();
    fetchAllProducts();
    fetchAllDesign();
    fetchAllPurity();
    getPacket();
    getAllBox();
    getAllBranch();
    getAllTransferTypes();
    getAllEmployee();
  }, []);
  const handleChange = (event) => {
    setSelectedValue(event.target.value);
    setFilterData({
      CategoryName: "",
      ProductName: "",
      DesignName: "",
      PurityName: "",
    });
    setFormData((prev) => ({
      ...prev,
      StockTransferTypeName: "",
      Source: "",
      Destination: "",
    }));
    setFromOptionKey("");
    setToOptionKey("");
    setCheckdata([]);
    setSelectedRows([]);
    setSelectAll(false);
  };
  const handleDateChange = (event) => {
    setSelectedDate(event.target.value);
  };
  const handleSelectAllChange = (e) => {
    const isChecked = e.target.checked;
    setSelectAll(isChecked);
    setSelectedRows(isChecked ? tableData.map((row) => row.Id) : []);
  };
  useEffect(() => {
    const totalgrosswt = data.reduce(
      (total, product) =>
        total +
        parseFloat(
          selectedValue === "labelled" ? product.GrossWt : product.TotalGrossWt
        ),
      0
    );
    const totalnetwt = data.reduce(
      (total, product) =>
        total +
        parseFloat(
          selectedValue === "labelled" ? product.NetWt : product.TotalNetWt
        ),
      0
    );
    setFormData({
      ...formData,
      TotalGrossWT: totalgrosswt,
      TotalNetWT: totalnetwt,
    });
  }, [data]);
  const handleRowCheckboxChange = (e, id) => {
    const isChecked = e.target.checked;
    setSelectedRows((prevState) =>
      isChecked ? [...prevState, id] : prevState.filter((rowId) => rowId !== id)
    );

    setCheckdata((prevCheckData) => {
      const selectedRow = tableData.find((row) => row.Id === id);
      const updatedCheckData = isChecked
        ? [...(prevCheckData || []), selectedRow]
        : (prevCheckData || []).filter((row) => row.Id !== id);

      return updatedCheckData;
    });
  };
  const isRowSelected = (id) => selectedRows.includes(id);
  const removeSelectedRows = () => {
    setTableData((prevTableData) => [...prevTableData, ...data]);
    setData([]);
    setRemoveAll(false);
  };
  const removeRow = (id) => {
    const rowToRemove = data.find((item) => item.Id === id);
    if (rowToRemove) {
      setTableData((prevTableData) => [...prevTableData, rowToRemove]);
      setData((prevData) => prevData.filter((item) => item.Id !== id));
    }
  };
  const handleChangeFilter = async (e) => {
    const { value, name } = e.target;
    setFilterData((list) => ({ ...list, [name]: value }));
  };
  const transferStock = () => {
    const selectedData = tableData?.filter((row) =>
      selectedRows.includes(row.Id)
    );
    setData((prevData) => [...prevData, ...selectedData]);
    setTableData((prevData) =>
      prevData.filter((row) => !selectedRows.includes(row.Id))
    );
    setSelectedRows([]);
    setFormData({
      ...formData,
      TotalGrossWT: 0,
      TotalNetWT: 0,
    });
    setSelectAll(false);
  };
  const handleInputChangePurchase = (e) => {
    const { name, value } = e.target;

    if (value.split(" ") && name === "StockTransferTypeName") {
      if (e.target.value.split(" ")[0] === "Packet") {
        setFromOptionKey("PacketName");
        setFromOption(packetsOption);
      }
      if (e.target.value.split(" ")[0] === "Box") {
        setFromOptionKey("BoxName");
        setFromOption(boxOption);
      }
      if (e.target.value.split(" ")[0] === "Branch") {
        setFromOptionKey("BranchName");
        setFromOption(branchOption);
      }
      if (e.target.value.split(" ")[0] === "Salesman") {
        setFromOptionKey("FirstName");
        setFromOption(salesmanOption);
      }
      if (e.target.value.split(" ")[0] === "Display") {
        setFromOptionKey("DisplayName");
        setFromOption([]);
      }
      if (e.target.value.split(" ")[2] === "Packet") {
        setToOptionKey("PacketName");
        setToOption(packetsOption);
      }
      if (e.target.value.split(" ")[2] === "Box") {
        setToOptionKey("BoxName");
        setToOption(boxOption);
      }
      if (e.target.value.split(" ")[2] === "Branch") {
        setToOptionKey("BranchName");
        setToOption(branchOption);
      }
      if (e.target.value.split(" ")[2] === "Salesman") {
        setToOptionKey("FirstName");
        setToOption(salesmanOption);
      }
      if (e.target.value.split(" ")[2] === "Display") {
        setToOptionKey("DisplayName");
        setToOption([]);
      }
    }
    if (
      name == "Source" &&
      formData.StockTransferTypeName.split(" ")[2] === "Packet" &&
      formData.StockTransferTypeName.split(" ")[0] === "Packet"
    ) {
      // setFromOptionKey('PacketName');
      // setToOptionKey('PacketName');
      const filterTo = packetsOption.filter(
        (item) => item.PacketName !== value
      );
      setToOption(filterTo);
    }
    if (
      name == "Source" &&
      formData.StockTransferTypeName.split(" ")[2] === "Box" &&
      formData.StockTransferTypeName.split(" ")[0] === "Box"
    ) {
      // setFromOptionKey('BoxName');
      // setToOptionKey('BoxName');
      const filterTo = boxOption.filter((item) => item.BoxName !== value);
      setToOption(filterTo);
    }
    if (
      name == "Source" &&
      formData.StockTransferTypeName.split(" ")[2] === "Branch" &&
      formData.StockTransferTypeName.split(" ")[0] === "Branch"
    ) {
      // setFromOptionKey('BranchName');
      // setToOptionKey('BranchName');
      const filterTo = branchOption.filter((item) => item.BranchName !== value);
      setToOption(filterTo);
    }
    setFormData((list) => ({ ...list, [name]: value }));
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    const transferData = data.map((item) => ({ stockId: item.Id }));
    const sourceItem = fromOption.find(
      (item, _) => item[`${fromOptionKey}`] === formData.Source
    );
    const destinationItem = toOption.find(
      (item, _) => item[`${toOptionKey}`] === formData.Destination
    );
    console.log(formData.StockTransferTypeName);
    const payload = {
      ClientCode: clientCode,
      StockTransferItems: transferData,
      StockType: selectedValue,
      StockTransferTypeName: formData.TransferType,
      TransferTypeId: transferType.find(
        (item, _) => item.TransferType === formData.StockTransferTypeName
      ).Id,
      TransferByEmployee: String(allEmployee?.[0]?.Id) || "0",
      TransferedToBranch: formData.TransferedToBranch,
      Source: sourceItem ? sourceItem.Id : 0,
      Destination: destinationItem ? destinationItem.Id : 0,
      Remarks: formData.Remarks,
      ReceivedByEmployee:
        formData.ReceivedBy === "Other"
          ? formData.ReceivedByEmployee
          : formData.ReceivedBy,
    };
    try {
      const response = await fetch(a235, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });
      const data = await response.json();
      setFormData({
        TransferByEmployee: "",
        TransferedToBranch: "",
        ReceivedByEmployee: "",
        ReceivedBy: "",
        Remarks: "",
        Source: "",
        Destination: "",
        StockTransferTypeName: "",
        StockTransferItems: [],
      });
      setFilterData({
        CategoryName: "",
        ProductName: "",
        DesignName: "",
        PurityName: "",
      });
      setData([]);
      setCheckdata([]);
      setSelectedRows([]);
      setSelectAll(false);
      setMessageType("success");
      setMessageToShow("Stock Transfer Successfully");
      setShowError(true);
      navigate("/stock_transfer_list");
    } catch (error) {
      console.log(error);
      setMessageType("error");
      setMessageToShow("Failed to Transfer Stock");
      setShowError(true);
    }
  };
  return (
    <>
      <AdminHeading />

      <Box className="adminMainBodyBox">
        {showError ? (
          <AlertMessage message={messageToShow} type={messageType} />
        ) : null}
        <AdminBreadCrump
          title={"Stock Transfer"}
          companyName={"Loyalstring"}
          module={"Trading"}
          page={"Stock Transfer"}
        />
      </Box>

      <Box className="adminAddCategoryMainBoxST">
        <Box className="adminAddCategoryInnerBoxST">
          <form onSubmit={handleSubmit}>
            {/* <Box
              id="adminInvoiceAddedCustomerEdit"
              className="adminInvoiceAddTitlesST"
            > */}
            {/* <Grid
                container
                sx={{
                  display: { xs: "block", md: "flex" },
                  justifyContent: { md: "space-between" },
                  alignItems: "center",
                }}
              > */}
            {/* <Grid item sm={12} md={8}>
                  <Grid
                    container
                    sx={{ display: "flex", alignItems: "center" }}
                  > */}
            <Grid container mt={2} spacing={2}>
              <div className="stock-transfer-box">
                <div className="stock-transfer-packet">
                  <label style={{ marginBottom: "8px" }}>
                    Transfer Type<sup>*</sup> :{" "}
                  </label>
                  <select
                    className={"input-select"}
                    name={"StockTransferTypeName"}
                    onChange={handleInputChangePurchase}
                    value={formData.StockTransferTypeName}
                    required={"required"}
                    style={{ width: "100%" }}
                  >
                    <option value="">Choose a Transfer Type</option>
                    {transferType &&
                      transferType.map((x, y) => (
                        <option key={y} value={x.TransferType}>
                          {x.TransferType}
                        </option>
                      ))}
                  </select>
                </div>
                <div className="stock-transfer-packet">
                  <label
                    style={{
                      textAlign: "right",
                      marginRight: "5px",
                      marginLeft: "10px",
                      marginBottom: "8px",
                    }}
                  >
                    From<sup>*</sup>:{" "}
                  </label>
                  <select
                    style={{ width: "100%" }}
                    className={"input-select"}
                    name={"Source"}
                    onChange={handleInputChangePurchase}
                    value={formData.Source}
                    required={"required"}
                  >
                    <option value="">From</option>
                    {fromOptionKey === "DisplayName" ? (
                      <option selected value={"Display"}>
                        Display
                      </option>
                    ) : (
                      fromOption.map((x, y) => (
                        <option key={y} value={x[`${fromOptionKey}`]}>
                          {x[`${fromOptionKey}`]}
                        </option>
                      ))
                    )}
                  </select>
                </div>
                <div className="stock-transfer-packet">
                  <label
                    style={{
                      marginBottom: "8px",
                      textAlign: "right",
                      marginRight: "5px",
                      marginLeft: "10px",
                    }}
                  >
                    To<sup>*</sup> :{" "}
                  </label>
                  <select
                    style={{ width: "100%" }}
                    className={"input-select"}
                    name={"Destination"}
                    onChange={handleInputChangePurchase}
                    value={formData.Destination}
                    required={"required"}
                  >
                    <option value="">To</option>
                    {toOptionKey === "DisplayName" ? (
                      <option selected value={"Display"}>
                        Display
                      </option>
                    ) : (
                      toOption.map((x, y) => (
                        <option key={y} value={x[`${toOptionKey}`]}>
                          {x[`${toOptionKey}`]}
                        </option>
                      ))
                    )}
                  </select>
                </div>
                <div style={{width: '38%'}} className="stock-transfer-packet">
                <Box
                  mt={2}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <label>
                      <input
                        type="radio"
                        name="stockType"
                        value="labelled"
                        checked={selectedValue === "labelled"}
                        onChange={handleChange}
                        style={{
                          marginRight: "5px",
                          outline: "none", // Removes the blue outline on focus
                        }}
                      />
                      Labelled Stock
                    </label>

                    <label style={{ marginLeft: "20px" }}>
                      <input
                        type="radio"
                        name="stockType"
                        value="unlabelled"
                        checked={selectedValue === "unlabelled"}
                        onChange={handleChange}
                        style={{
                          marginRight: "5px",
                          outline: "none", // Removes the blue outline on focus
                        }}
                      />
                      Unlabelled Stock
                    </label>
                  </div>
                </Box>
                </div>
                
              </div>
            </Grid>
            {/* </Grid>
                </Grid> */}

            {/* </Grid> */}
            {/* </Box> */}

            {/* <Box
              mt={2}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <RadioGroup row value={selectedValue} onChange={handleChange}>
                  <FormControlLabel
                    value="labelled"
                    control={
                      <Radio
                        sx={{ transform: "scale(0.7)", marginRight: -1 }}
                      />
                    }
                    label="Labelled Stock"
                    sx={{ " span": { fontSize: "0.9rem" } }}
                  />
                  <FormControlLabel
                    value="unlabelled"
                    control={
                      <Radio
                        sx={{ transform: "scale(0.7)", marginRight: -1 }}
                      />
                    }
                    label="Unlabelled Stock"
                    sx={{ " span": { fontSize: "0.9rem" } }}
                  />
                </RadioGroup>
              </Box>
            </Box> */}
            <Grid container mt={2} spacing={2}>
              <div className="stock-transfer-box">
                <div className="stock-transfer-packet">
                  <label style={{ marginBottom: "8px", display: "block" }}>
                    Category
                  </label>
                  <select
                    className={"input-select"}
                    name={"CategoryName"}
                    onChange={handleChangeFilter}
                    value={filterData.CategoryName}
                    style={{ width: "100%" }}
                  >
                    <option value="">Choose a Category</option>
                    {allCategories.map((x, y) => (
                      <option key={y} value={x.CategoryName}>
                        {x.CategoryName}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="stock-transfer-packet">
                  <label style={{ marginBottom: "8px", display: "block" }}>
                    Product
                  </label>
                  <select
                    className={"input-select"}
                    name={"ProductName"}
                    onChange={handleChangeFilter}
                    value={filterData.ProductName}
                    style={{ width: "100%" }}
                  >
                    <option value="">Choose a Product</option>
                    {filterData.CategoryName &&
                      allProducts
                        .filter(
                          (item) =>
                            item.CategoryName === filterData.CategoryName
                        )
                        .map((x, y) => (
                          <option key={y} value={x.ProductName}>
                            {x.ProductName}
                          </option>
                        ))}
                  </select>
                </div>
                <div className="stock-transfer-packet">
                  <label style={{ marginBottom: "8px", display: "block" }}>
                    Design
                  </label>
                  <select
                    className={"input-select"}
                    name={"DesignName"}
                    onChange={handleChangeFilter}
                    value={filterData.DesignName}
                    style={{ width: "100%" }}
                  >
                    <option value="">Choose a Design</option>
                    {filterData.ProductName &&
                      filterData.CategoryName &&
                      allDesign
                        .filter(
                          (item) => item.ProductName === filterData.ProductName
                        )
                        .map((x, y) => (
                          <option key={y} value={x.DesignName}>
                            {x.DesignName}
                          </option>
                        ))}
                  </select>
                </div>
                <div className="stock-transfer-packet">
                  <label style={{ marginBottom: "8px", display: "block" }}>
                    Purity
                  </label>
                  <select
                    className={"input-select"}
                    name={"PurityName"}
                    onChange={handleChangeFilter}
                    value={filterData.PurityName}
                    style={{ width: "100%" }}
                  >
                    <option value="">Choose a Purity</option>
                    {filterData.CategoryName &&
                      allPurity
                        .filter(
                          (item) =>
                            item.CategoryName === filterData.CategoryName
                        )
                        .map((x, y) => (
                          <option key={y} value={x.PurityName}>
                            {x.PurityName}
                          </option>
                        ))}
                  </select>
                </div>
                <div className="stock-transfer-packet">
                 
                    
                        <label
                          htmlFor="datePicker"
                           style={{ margin: "0px 5px" }}
                        >
                          Date {" "}
                        </label>
                        <input
                          type="date"
                          id="datePicker"
                          value={selectedDate}
                          onChange={handleDateChange}
                          variant="outlined"
                          size="small"
                          InputLabelProps={{ shrink: true }}
                          style={{
                            backgroundColor: "#fff",
                            "& input": { height: "0.7em" },
                          }}
                        />
                      
                   
                

                </div>

                {/* <div className="stock-transfer-packet">
                  <label style={{ marginLeft: "5px" }}>Select All</label>
                  <input
                    type="checkbox"
                    className="select-all-checkbox"
                    id="selectAll"
                    checked={selectAll}
                    onChange={handleSelectAllChange}
                    style={{ outline: "none", boxShadow: "none" }}
                  />
                </div> */}

                {/* <div className="stock-transfer-packet">
                  <label style={{ marginLeft: "5px" }}>Remove All</label>
                  <input
                    type="checkbox"
                    checked={removeAll}
                    onClick={removeSelectedRows}
                    style={{ outline: "none", boxShadow: "none" }}
                  />
                </div> */}
              </div>
            </Grid>

            {/* <Grid
              container
              alignItems="flex-start"
              justifyContent="space-between"
              spacing={2}
              sx={{ my: 2 }}
            >
           
              <Grid item xs={5}>
                {isLoading ? (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "50vh",
                    }}
                  >
                    <InfinitySpin width="200" color="#4fa94d" />
                  </Box>
                ) : (
                  <TableContainer
                    sx={{
                      height: "50vh",
                      overflowY: "auto",
                      "th, td": { border: "1px solid #ccc" },
                      borderRadius: "4px",
                    }}
                  >
                    <Table
                      size="small"
                      aria-label="first table"
                      sx={{ borderCollapse: "collapse" }}
                    >
                      <TableHead>
                        <TableRow>
                          <TableCell
                            align="center"
                            style={{ width: "fit-content" }}
                            sx={{
                              fontWeight: "600",
                              backgroundColor: "#627383",
                              color: "#fff",
                              padding: "1px 4px !important",
                             
                            }}
                          >
                            Sr
                          </TableCell>
                          <TableCell
                            align="center"
                            sx={{
                              fontWeight: "600",
                              backgroundColor: "#627383",
                              color: "#fff",
                              padding: "1px 4px !important",
                            }}
                          >
                            Product Name
                          </TableCell>
                          <TableCell
                            align="center"
                            sx={{
                              fontWeight: "600",
                              backgroundColor: "#627383",
                              color: "#fff",
                              padding: "1px 4px !important",
                            }}
                          >
                            Label
                          </TableCell>
                          <TableCell
                            align="center"
                            sx={{
                              fontWeight: "600",
                              backgroundColor: "#627383",
                              color: "#fff",
                              padding: "1px 4px !important",
                            }}
                          >
                            Gross WT
                          </TableCell>
                          <TableCell
                            align="center"
                            sx={{
                              fontWeight: "600",
                              backgroundColor: "#627383",
                              color: "#fff",
                              padding: "1px 4px !important",
                            }}
                          >
                            Net WT
                          </TableCell>
                          <TableCell
                            align="center"
                            sx={{
                              fontWeight: "600",
                              backgroundColor: "#627383",
                              color: "#fff",
                              padding: "1px 4px !important",
                            }}
                          >
                            Transfer
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {tableData &&
                          fromOptionKey &&
                          tableData.map((item, index) => (
                            <TableRow key={item.id}>
                              <TableCell align="center">{index + 1}</TableCell>
                              <TableCell align="center">
                                {selectedValue === "labelled"
                                  ? item.ProductName
                                  : item.DesignName}
                              </TableCell>
                              <TableCell align="center">
                                {selectedValue === "labelled"
                                  ? item.ItemCode
                                  : item.ItemCode}
                              </TableCell>
                              <TableCell align="center">
                                {selectedValue === "labelled"
                                  ? item.GrossWt
                                  : item.TotalGrossWt}
                              </TableCell>
                              <TableCell align="center">
                                {selectedValue === "labelled"
                                  ? item.NetWt
                                  : item.TotalNetWt}
                              </TableCell>
                              <TableCell align="center">
                                <input
                                  type="checkbox"
                                  checked={isRowSelected(item.Id)}
                                  onChange={(e) =>
                                    handleRowCheckboxChange(e, item.Id)
                                  }
                                />
                              </TableCell>
                            </TableRow>
                          ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                )}
              </Grid>

              
              <Grid
    item
    xs={1}
    container
    justifyContent="center"
    alignItems="center"
  >
              <button
              type="button"
                style={{
                  backgroundColor: "#0077d4",
                  color: "white",
                  border: "none",
                  padding: "10px",
                  borderRadius: "5px",
                  cursor: "pointer",
                  height: "60px",
                }}
                onClick={transferStock}
              >
                Transfer Stock
                <Icon icon="weui:arrow-filled" width="24" height="24" />
                <Icon icon="weui:arrow-filled" width="24" height="24" />
              </button>
              </Grid>

            
              <Grid item xs={5}>
                <TableContainer
                  sx={{
                    height: "50vh",
                    overflowY: "auto",
                    "th, td": { border: "1px solid #ccc" },
                    borderRadius: "4px",
                  }}
                >
                  <Table
                    size="small"
                    aria-label="second table"
                    sx={{ borderCollapse: "collapse" }}
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell
                          align="center"
                          sx={{
                            fontWeight: "600",
                            backgroundColor: "#627383",
                            color: "#fff",
                            padding: "1px 4px !important",
                          }}
                        >
                          Sr
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={{
                            fontWeight: "600",
                            backgroundColor: "#627383",
                            color: "#fff",
                            padding: "1px 4px !important",
                          }}
                        >
                          Product Name
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={{
                            fontWeight: "600",
                            backgroundColor: "#627383",
                            color: "#fff",
                            padding: "1px 4px !important",
                          }}
                        >
                          Label
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={{
                            fontWeight: "600",
                            backgroundColor: "#627383",
                            color: "#fff",
                            padding: "1px 4px !important",
                          }}
                        >
                          Gross WT
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={{
                            fontWeight: "600",
                            backgroundColor: "#627383",
                            color: "#fff",
                            padding: "1px 4px !important",
                          }}
                        >
                          Net WT
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={{
                            fontWeight: "600",
                            backgroundColor: "#627383",
                            color: "#fff",
                            padding: "1px 4px !important",
                          }}
                        >
                          Remove
                        </TableCell>
                      </TableRow>
                    </TableHead>

                    <TableBody>
                      {data.map((item, index) => (
                        <TableRow key={item.id}>
                          <TableCell align="center">{index + 1}</TableCell>
                          <TableCell align="center">
                            {selectedValue === "labelled"
                              ? item.ProductName
                              : item.DesignName}
                          </TableCell>
                          <TableCell align="center">{item.ItemCode}</TableCell>
                          <TableCell align="center">
                            {selectedValue === "labelled"
                              ? item.GrossWt
                              : item.TotalGrossWt}
                          </TableCell>
                          <TableCell align="center">
                            {selectedValue === "labelled"
                              ? item.NetWt
                              : item.TotalNetWt}
                          </TableCell>
                          <TableCell align="center">
                            <Typography
                              variant="body2"
                              color="error"
                              onClick={() => removeRow(item.Id)}
                              sx={{ cursor: "pointer" }}
                            >
                              X
                            </Typography>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
            </Grid> */}

            <div className="table-containerST">
              <div
                style={{
                  height: "50vh",
                  overflowY: "auto",
                  width: "fit-content",
                  border: "1px solid #ccc",
                  borderRadius: "10px",
                }}
              >
                <table
                  style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    tableLayout: "auto", // Allow column widths to adjust automatically
                  }}
                >
                  <thead>
                    <tr>
                      <th
                        style={{
                          fontWeight: "600",
                          backgroundColor: "#627383",
                          color: "#fff",
                          padding: "2px 5px",
                          border: "1px solid #ccc",
                          whiteSpace: "nowrap",
                          width: "50px", // Set width for "Sr" column
                        }}
                      >
                        Sr
                      </th>
                      <th
                        style={{
                          fontWeight: "600",
                          backgroundColor: "#627383",
                          color: "#fff",
                          padding: "2px 5px",
                          border: "1px solid #ccc",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Product Name
                      </th>
                      <th
                        style={{
                          fontWeight: "600",
                          backgroundColor: "#627383",
                          color: "#fff",
                          padding: "2px 5px",
                          border: "1px solid #ccc",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Label
                      </th>
                      <th
                        style={{
                          fontWeight: "600",
                          backgroundColor: "#627383",
                          color: "#fff",
                          padding: "2px 5px",
                          border: "1px solid #ccc",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Gross WT
                      </th>
                      <th
                        style={{
                          fontWeight: "600",
                          backgroundColor: "#627383",
                          color: "#fff",
                          padding: "2px 5px",
                          border: "1px solid #ccc",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Net WT
                      </th>
                      {/* <th
                        style={{
                          fontWeight: "600",
                          backgroundColor: "#627383",
                          color: "#fff",
                          padding: "2px 5px",
                          border: "1px solid #ccc",
                          whiteSpace: "nowrap",
                          display: "flex",
                        }}
                      >
                        Transfer

                        <div style={{backgroundColor: '#fff'}}>
                        <input
                    type="checkbox"
                    className="select-all-checkbox"
                    id="selectAll"
                    checked={selectAll}
                    onChange={handleSelectAllChange}
                    style={{ outline: "none", boxShadow: "none", color: '#fff' }}
                  />
                        </div>

                        
                      </th> */}

                      <th
                        style={{
                          fontWeight: "600",
                          backgroundColor: "#627383", // Parent background matches gray
                          color: "#fff",
                          padding: "2px 5px",
                          border: "1px solid #ccc",
                          whiteSpace: "nowrap",
                          display: "flex",
                          alignItems: "center", // Ensure alignment
                          justifyContent: "space-between", // Space between text and checkbox
                        }}
                      >
                        Transfer
                        <div
                          style={{
                            backgroundColor: "#627383", // Same gray as parent
                            padding: "2px", // Small padding around checkbox
                            borderRadius: "3px", // Rounded edges for aesthetics
                          }}
                        >
                          <input
                            type="checkbox"
                            className="select-all-checkbox"
                            id="selectAll"
                            checked={selectAll}
                            onChange={handleSelectAllChange}
                            style={{
                              outline: "none",
                              boxShadow: "none",
                              backgroundColor: "#fff", // White background for the checkbox
                              border: "1px solid #ccc", // Border around checkbox for clarity
                              width: "16px", // Adjust size if needed
                              height: "16px", // Adjust size if needed
                            }}
                          />
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {tableData &&
                      fromOptionKey &&
                      tableData.map((item, index) => (
                        <tr key={item.id}>
                          <td
                            style={{
                              textAlign: "center",
                              border: "1px solid #ccc",
                              padding: "1px 4px",
                              fontSize: "12px",
                            }}
                          >
                            {index + 1}
                          </td>
                          <td
                            style={{
                              textAlign: "center",
                              border: "1px solid #ccc",
                              padding: "1px 4px",
                              fontSize: "12px",
                            }}
                          >
                            {selectedValue === "labelled"
                              ? item.ProductName
                              : item.DesignName}
                          </td>
                          <td
                            style={{
                              textAlign: "center",
                              border: "1px solid #ccc",
                              padding: "1px 4px",
                              fontSize: "12px",
                            }}
                          >
                            {item.ItemCode}
                          </td>
                          <td
                            style={{
                              textAlign: "center",
                              border: "1px solid #ccc",
                              padding: "1px 4px",
                              fontSize: "12px",
                            }}
                          >
                            {selectedValue === "labelled"
                              ? item.GrossWt
                              : item.TotalGrossWt}
                          </td>
                          <td
                            style={{
                              textAlign: "center",
                              border: "1px solid #ccc",
                              padding: "1px 4px",
                              fontSize: "12px",
                            }}
                          >
                            {selectedValue === "labelled"
                              ? item.NetWt
                              : item.TotalNetWt}
                          </td>
                          <td
                            style={{
                              textAlign: "center",
                              border: "1px solid #ccc",
                              padding: "1px 4px",
                              fontSize: "12px",
                            }}
                          >
                            <input
                              type="checkbox"
                              checked={isRowSelected(item.Id)}
                              onChange={(e) =>
                                handleRowCheckboxChange(e, item.Id)
                              }
                            />
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
              <button
                type="button"
                // style={{
                //   backgroundColor: "#0077d4",
                //   color: "white",
                //   border: "none",
                //   padding: "10px",
                //   borderRadius: "5px",
                //   cursor: "pointer",
                //   height: '60px'
                // }}
                onClick={transferStock}
              >
                Transfer Stock
              </button>
              <div
                style={{
                  height: "50vh",
                  overflowY: "auto",
                  border: "1px solid #ccc",
                  borderRadius: "10px",
                }}
              >
                <table
                  style={{
                    borderCollapse: "collapse",
                    width: "100%",
                    fontFamily: "Arial, sans-serif",
                    tableLayout: "auto",
                  }}
                >
                  <thead>
                    <tr style={{ backgroundColor: "#627383", color: "white" }}>
                      <th
                        style={{
                          textAlign: "center",
                          fontWeight: 600,
                          padding: "2px 5px",
                          border: "1px solid #ccc",
                          width: "50px",
                          backgroundColor: "#627383",
                          color: "#fff",
                        }}
                      >
                        Sr
                      </th>
                      <th
                        style={{
                          textAlign: "center",
                          fontWeight: 600,
                          padding: "2px 5px",
                          border: "1px solid #ccc",
                          backgroundColor: "#627383",
                          color: "#fff",
                        }}
                      >
                        Product Name
                      </th>
                      <th
                        style={{
                          textAlign: "center",
                          fontWeight: 600,
                          padding: "2px 5px",
                          border: "1px solid #ccc",
                          backgroundColor: "#627383",
                          color: "#fff",
                        }}
                      >
                        Label
                      </th>
                      <th
                        style={{
                          textAlign: "center",
                          fontWeight: 600,
                          padding: "2px 5px",
                          border: "1px solid #ccc",
                          backgroundColor: "#627383",
                          color: "#fff",
                        }}
                      >
                        Gross WT
                      </th>
                      <th
                        style={{
                          textAlign: "center",
                          fontWeight: 600,
                          padding: "2px 5px",
                          border: "1px solid #ccc",
                          backgroundColor: "#627383",
                          color: "#fff",
                        }}
                      >
                        Net WT
                      </th>
                      <th
                        style={{
                          fontWeight: "600",
                          backgroundColor: "#627383", // Parent background matches gray
                          color: "#fff",
                          padding: "2px 5px",
                          border: "1px solid #ccc",
                          whiteSpace: "nowrap",
                          display: "flex",
                          alignItems: "center", // Ensure alignment
                          justifyContent: "space-between", // Space between text and checkbox
                        }}
                      >
                        Remove
                        <div
                          style={{
                            backgroundColor: "#627383", // Same gray as parent
                            padding: "2px", // Small padding around checkbox
                            borderRadius: "3px", // Rounded edges for aesthetics
                          }}
                        >
                          <input
                            type="checkbox"
                            checked={removeAll}
                            onClick={removeSelectedRows}
                            style={{
                              outline: "none",
                              boxShadow: "none",
                              backgroundColor: "#fff", // White background for the checkbox
                              border: "1px solid #ccc", // Border around checkbox for clarity
                              width: "16px", // Adjust size if needed
                              height: "16px", // Adjust size if needed
                            }}
                          />
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.map((item, index) => (
                      <tr key={item.id}>
                        <td
                          style={{
                            textAlign: "center",
                            border: "1px solid #ccc",
                            fontSize: "12px",
                            padding: "1px 4px",
                          }}
                        >
                          {index + 1}
                        </td>
                        <td
                          style={{
                            textAlign: "center",
                            border: "1px solid #ccc",
                            fontSize: "12px",
                            padding: "1px 4px",
                          }}
                        >
                          {selectedValue === "labelled"
                            ? item.ProductName
                            : item.DesignName}
                        </td>
                        <td
                          style={{
                            textAlign: "center",
                            border: "1px solid #ccc",
                            fontSize: "12px",
                            padding: "1px 4px",
                          }}
                        >
                          {item.ItemCode}
                        </td>
                        <td
                          style={{
                            textAlign: "center",
                            border: "1px solid #ccc",
                            fontSize: "12px",
                            padding: "1px 4px",
                          }}
                        >
                          {selectedValue === "labelled"
                            ? item.GrossWt
                            : item.TotalGrossWt}
                        </td>
                        <td
                          style={{
                            textAlign: "center",
                            border: "1px solid #ccc",
                            fontSize: "12px",
                            padding: "1px 4px",
                          }}
                        >
                          {selectedValue === "labelled"
                            ? item.NetWt
                            : item.TotalNetWt}
                        </td>
                        <td
                          style={{
                            textAlign: "center",
                            border: "1px solid #ccc",
                            fontSize: "12px",
                            padding: "1px 4px",
                          }}
                        >
                          <span
                            style={{
                              color: "red",
                              cursor: "pointer",
                              fontSize: "14px",
                            }}
                            onClick={() => removeRow(item.Id)}
                          >
                            {/* X */}
                            <Icon
                              icon="material-symbols-light:delete"
                              width="20"
                              height="20"
                              style={{ color: "#627383" }}
                            />
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            {/* <Grid container>
              <Grid
                item
             
              >
                <Grid container spacing={3} wrap="nowrap">
                  <Grid item>
                    <Box sx={{ width: "100%" }}>
                      <label
                        style={{
                          display: "block",
                          textAlign: "start",
                          marginBottom: "5px",
                          fontSize: "15px",
                        }}
                      >
                        Transferred By<sup>*</sup>
                      </label>
                      <select
                        style={{ width: "100%", height: "30px" }}
                        className={"input-select"}
                        name={"TransferByEmployee"}
                        onChange={handleInputChangePurchase}
                        value={
                          formData.TransferByEmployee ||
                          allEmployee?.[0]?.Id ||
                          ""
                        }
                        disabled
                        required={"required"}
                      >
                        <option value="">Select Transferred By</option>
                        {allEmployee?.map((x, y) => (
                          <option key={y} value={x.Id}>
                            {x.FirstName} {x.LastName}
                          </option>
                        ))}
                      </select>
                    </Box>
                  </Grid>
                  <Grid item>
                    <Box sx={{ width: "100%" }}>
                      <label
                        style={{
                          display: "block",
                          textAlign: "start",
                          marginBottom: "5px",
                          fontSize: "15px",
                        }}
                      >
                        Transferred To
                        <sup>
                          {formData.StockTransferTypeName.includes(
                            "Salesman"
                          ) ||
                          formData.StockTransferTypeName === "Branch To Branch"
                            ? "*"
                            : null}
                        </sup>
                      </label>
                      <select
                        style={{ width: "100%", height: "30px" }}
                        className={"input-select"}
                        name={"TransferedToBranch"}
                        onChange={handleInputChangePurchase}
                        value={formData.TransferedToBranch}
                        required={
                          formData.StockTransferTypeName.includes("Salesman") ||
                          formData.StockTransferTypeName === "Branch To Branch"
                            ? true
                            : false
                        }
                      >
                        <option value="">Select Transferred To</option>
                       
                        {branchOption.map((x, y) => (
                          <option key={y} value={x.Id}>
                            {x.BranchName}
                          </option>
                        ))}
                      </select>
                    </Box>
                  </Grid>
                  <Grid item>
                    <Box sx={{ width: "100%", marginTop: "3px" }}>
                      <label
                        style={{
                          display: "block",
                          textAlign: "start",
                          marginBottom: "5px",
                          fontSize: "15px",
                        }}
                      >
                        Total Gross WT
                      </label>
                      <input
                        style={{
                          width: "100%",
                          height: "30px",
                          border: "1px solid #ccc",
                        }}
                        type="text"
                        className={"input-select"}
                        name={"TotalGrossWT"}
                        value={formData.TotalGrossWT}
                        readOnly
                        onChange={handleInputChangePurchase}
                      />
                    </Box>
                  </Grid>
                  <Grid item>
                    <Box sx={{ width: "100%", marginTop: "3px" }}>
                      <label
                        style={{
                          display: "block",
                          textAlign: "start",
                          marginBottom: "5px",
                          fontSize: "15px",
                        }}
                      >
                        Total Net WT
                      </label>
                      <input
                        style={{
                          width: "100%",
                          height: "30px",
                          border: "1px solid #ccc",
                        }}
                        type="text"
                        className={"input-select"}
                        name={"TotalNetWT"}
                        value={formData.TotalNetWT}
                        readOnly
                        onChange={handleInputChangePurchase}
                      />
                    </Box>
                  </Grid>
                  <Grid item>
                    <Box sx={{ width: "100%" }}>
                      <label
                        style={{
                          display: "block",
                          textAlign: "start",
                          marginBottom: "5px",
                          fontSize: "15px",
                        }}
                      >
                        Received By
                        <sup>
                          {formData.StockTransferTypeName.includes(
                            "Salesman"
                          ) ||
                          formData.StockTransferTypeName === "Branch To Branch"
                            ? "*"
                            : null}
                        </sup>
                      </label>
                      <select
                        style={{ width: "100%", height: "30px" }}
                        className={"input-select"}
                        name={"ReceivedBy"}
                        required={
                          formData.StockTransferTypeName.includes("Salesman") ||
                          formData.StockTransferTypeName === "Branch To Branch"
                            ? true
                            : false
                        }
                        onChange={handleInputChangePurchase}
                        value={formData.ReceivedBy}
                      >
                        <option value="">Select an option</option>
                        {(() => {
                         
                          const { StockTransferTypeName } = formData;

                          let filteredEmployees = allEmployee;
                          if (StockTransferTypeName.includes("Salesman")) {
                            filteredEmployees = allEmployee.filter(
                              (item) => item.Id !== allEmployee?.[0]?.Id
                            );
                          } else if (
                            StockTransferTypeName === "Branch To Branch"
                          ) {
                            filteredEmployees = allEmployee.filter(
                              (item) =>
                                item.BranchName !== allEmployee?.[0]?.BranchName
                            );
                          }
                          return filteredEmployees.map((x, y) => (
                            <option key={y} value={x.Id}>
                              {x.FirstName} {x.LastName}
                            </option>
                          ));
                        })()}
                        <option value="Other">Other</option>
                      </select>
                    </Box>
                  </Grid>
                  {formData.ReceivedBy === "Other" && (
                    <>
                      <Grid item>
                        <Box sx={{ width: "100%", height: "30px" }}>
                          <label
                            style={{
                              display: "block",
                              textAlign: "start",
                              marginBottom: "5px",
                              fontSize: "15px",
                            }}
                          >
                            Received By{" "}
                            <sup>
                              {formData.StockTransferTypeName.includes(
                                "Salesman"
                              ) ||
                              formData.StockTransferTypeName ===
                                "Branch To Branch"
                                ? "*"
                                : null}
                            </sup>
                          </label>
                          <input
                            style={{ width: "100%" }}
                            type="text"
                            className={"input-select"}
                            required={
                              formData.StockTransferTypeName.includes(
                                "Salesman"
                              ) ||
                              formData.StockTransferTypeName ===
                                "Branch To Branch"
                                ? true
                                : false
                            }
                            name={"ReceivedByEmployee"}
                            onChange={handleInputChangePurchase}
                            value={formData.ReceivedByEmployee}
                          />
                        </Box>
                      </Grid>
                    </>
                  )}
                  <Grid item>
                    <Box sx={{ width: "100%" }}>
                      <label
                        style={{
                          display: "block",
                          textAlign: "start",
                          marginBottom: "5px",
                          fontSize: "15px",
                        }}
                      >
                        Remark
                      </label>
                      <input
                        style={{
                          width: "100%",
                          height: "30px",
                          marginTop: "3px",
                          border: "1px solid #ccc",
                        }}
                        type="text"
                        className={"input-select"}
                        name={"Remarks"}
                        onChange={handleInputChangePurchase}
                        value={formData.Remarks}
                      />
                    </Box>
                  </Grid>
                </Grid>
              </Grid>
            </Grid> */}

            <Grid
              container
              spacing={3}
              direction={{ xs: "column", lg: "row" }}
              wrap="nowrap"
              marginTop={'20px'}
            >
              {/* Transferred By */}
              <Grid item xs={12} lg>
                <Box sx={{ width: "100%" }}>
                  <label
                    style={{
                      display: "block",
                      textAlign: "start",
                      marginBottom: "5px",
                      fontSize: "15px",
                    }}
                  >
                    Transferred By<sup>*</sup>
                  </label>
                  <select
                    style={{ width: "100%", height: "30px" }}
                    className={"input-select"}
                    name={"TransferByEmployee"}
                    onChange={handleInputChangePurchase}
                    value={
                      formData.TransferByEmployee || allEmployee?.[0]?.Id || ""
                    }
                    disabled
                    required
                  >
                    <option value="">Select Transferred By</option>
                    {allEmployee?.map((x, y) => (
                      <option key={y} value={x.Id}>
                        {x.FirstName} {x.LastName}
                      </option>
                    ))}
                  </select>
                </Box>
              </Grid>

              {/* Transferred To */}
              <Grid item xs={12} lg>
                <Box sx={{ width: "100%" }}>
                  <label
                    style={{
                      display: "block",
                      textAlign: "start",
                      marginBottom: "5px",
                      fontSize: "15px",
                    }}
                  >
                    Transferred To<sup>*</sup>
                  </label>
                  <select
                    style={{ width: "100%", height: "30px" }}
                    className={"input-select"}
                    name={"TransferedToBranch"}
                    onChange={handleInputChangePurchase}
                    value={formData.TransferedToBranch}
                    required
                  >
                    <option value="">Select Transferred To</option>
                    {branchOption.map((x, y) => (
                      <option key={y} value={x.Id}>
                        {x.BranchName}
                      </option>
                    ))}
                  </select>
                </Box>
              </Grid>

              {/* Total Gross WT */}
              <Grid item xs={12} lg>
                <Box sx={{ width: "100%" }}>
                  <label
                    style={{
                      display: "block",
                      textAlign: "start",
                      marginBottom: "5px",
                      fontSize: "15px",
                    }}
                  >
                    Total Gross WT
                  </label>
                  <input
                    style={{
                      width: "100%",
                      height: "30px",
                      border: "1px solid #ccc",
                    }}
                    type="text"
                    className={"input-select"}
                    name={"TotalGrossWT"}
                    value={formData.TotalGrossWT}
                    readOnly
                    onChange={handleInputChangePurchase}
                  />
                </Box>
              </Grid>

              {/* Total Net WT */}
              <Grid item xs={12} lg>
                <Box sx={{ width: "100%" }}>
                  <label
                    style={{
                      display: "block",
                      textAlign: "start",
                      marginBottom: "5px",
                      fontSize: "15px",
                    }}
                  >
                    Total Net WT
                  </label>
                  <input
                    style={{
                      width: "100%",
                      height: "30px",
                      border: "1px solid #ccc",
                    }}
                    type="text"
                    className={"input-select"}
                    name={"TotalNetWT"}
                    value={formData.TotalNetWT}
                    readOnly
                    onChange={handleInputChangePurchase}
                  />
                </Box>
              </Grid>

              {/* Remarks */}
              <Grid item xs={12} lg>
                <Box sx={{ width: "100%" }}>
                  <label
                    style={{
                      display: "block",
                      textAlign: "start",
                      marginBottom: "5px",
                      fontSize: "15px",
                    }}
                  >
                    Remark
                  </label>
                  <input
                    style={{
                      width: "100%",
                      height: "30px",
                      border: "1px solid #ccc",
                    }}
                    type="text"
                    className={"input-select"}
                    name={"Remarks"}
                    onChange={handleInputChangePurchase}
                    value={formData.Remarks}
                  />
                </Box>
              </Grid>
            </Grid>

            <Box
              sx={{
                display: "flex",
                justifyContent: "end",
                my: "15px",
                gap: 2,
              }}
              className={"adminInvoiceAddProductsOptionsMainPurchaseItems"}
            >
              <Box>
                <button
                  style={{ backgroundColor: "#0077d4", color: "#fff" }}
                  type={"submit"}
                >
                  <Icon icon="ic:sharp-check" width="24" height="24" />
                  Save
                </button>
              </Box>
              <Box>
                <button
                  style={{ backgroundColor: "#0077d4", color: "#fff" }}
                  onClick={() => navigate("/stock_transfer_list")}
                >
                  <Icon
                    icon="fluent:list-rtl-16-filled"
                    width="24"
                    height="24"
                  />
                  List
                </button>
              </Box>
            </Box>
          </form>
        </Box>
      </Box>
    </>
  );
}

export default AdminStockTransfer;
